// API Configuration
// This file centralizes all API endpoints for the main server

// Read from environment or use default (empty string = same origin for production)
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const API_ENDPOINTS = {
    // Authentication
    AUTH: {
        LOGIN: `${API_BASE_URL}/api/auth/login`,
        REGISTER: `${API_BASE_URL}/api/auth/register`,
        LOGOUT: `${API_BASE_URL}/api/auth/logout`,
        VERIFY: `${API_BASE_URL}/api/auth/verify`,
        SETUP_STATUS: `${API_BASE_URL}/api/auth/setup-status`,
        PROFILE: `${API_BASE_URL}/api/auth/profile`,
        CHANGE_PASSWORD: `${API_BASE_URL}/api/auth/change-password`,
        USERS: `${API_BASE_URL}/api/auth/users`,
    },

    SYSTEM: {
        CLEAR_CACHE: `${API_BASE_URL}/api/dashboard/system/clear-cache`,
    },

    // Dashboard
    DASHBOARD: {
        STATS: `${API_BASE_URL}/api/dashboard/stats`,
        LICENSES: `${API_BASE_URL}/api/dashboard/licenses`,
        ACTIVITY: `${API_BASE_URL}/api/dashboard/activity`,
        ANALYTICS: `${API_BASE_URL}/api/dashboard/analytics`,
        LICENSE_DETAILS: (id: string) => `${API_BASE_URL}/api/dashboard/license/${id}`,
    },

    // License Operations
    LICENSE: {
        VALIDATE: `${API_BASE_URL}/validate`,
        RENEW: `${API_BASE_URL}/renew`,
        CHECK_PENDING_ACTIONS: `${API_BASE_URL}/check-pending-actions`,
        ACKNOWLEDGE_ACTION: `${API_BASE_URL}/acknowledge-action`,
        SERVER_PUBLIC_KEY: `${API_BASE_URL}/server-public-key`,
    },

    // Health
    HEALTH: {
        STATUS: `${API_BASE_URL}/health`,
        SERVER_INFO: `${API_BASE_URL}/server`,
    },
};

export default API_ENDPOINTS;
